/*--------------------------------------------*\
    Include Globally Useful JS Functions
\*--------------------------------------------*/

ThemeJS.Functions = (function ( $, root ) {

    function send_ajax_request ( args ) {
        args.data.nonce = ThemeJS.Variables.Ajax.nonce;
        $.post( ThemeJS.Variables.Ajax.url, args.data, function ( response ) {
            response = JSON.parse( response );
            if ( !response.hasOwnProperty( 'data' ) ) { response.data = {}; }
            if ( response.success && typeof args.success == 'function' ) {
                args.success( response.data );
            } else if ( !response.success && typeof args.error == 'function' ) {
                args.error( response.data );
            }
        });
    }

    function get_query_parameter( name, url ) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&#]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    return {
        send_ajax_request: send_ajax_request,
        get_query_parameter: get_query_parameter
    }







})( jQuery, this );



jQuery('.btn-toggle-search').attr('role', 'button');
jQuery('.contact-button a').attr('role', 'button');
jQuery('.menu').attr('role', 'menu');


jQuery('a[target=_blank]').each(function () {
    jQuery(this).append('<span class="screen-reader-text">opens a new window</span>')
});


jQuery('.menu-item-has-children a').attr('aria-haspopup', 'true').attr('aria-expanded', 'false').attr('role', 'button');;


jQuery(function(){
    jQuery('.menu-item-has-children a').hover(function() {
        jQuery('.menu-item-has-children a').attr('aria-expanded', 'true');
    }, function() {
        jQuery('.menu-item-has-children a').attr('aria-expanded', 'false');
    })
})
